import React, { FC, useEffect, useState } from "react";
import axiosInstant from "../../../../api";
import { SingleFilter } from "./singleFilter";
import { ISingleOption, getFilterProps } from "./helper";
import { useUser } from "../../../../hooks/useUser";
import { getBrandEmbeds } from "../../../../api/endpoints";
import { IEmbed } from "../../embeds/embedsV2/interface";
// eslint-disable-next-line import/no-cycle
import { CreateNewStory } from "../../embeds/embedsV2/CreateNewStory";
import { IconStory } from "../../../../utils/icons";
import { useWorkspaceBrandId } from '../../../../hooks/useWorkspaceBrandId';

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  creatable?: boolean;
  refreshKey?: number;
}

export const StoryFilter: FC<Props> = ({ creatable, onFilterSelect, refreshKey }) => {
  const { brand } = useUser();
  const workspaceBrandId = useWorkspaceBrandId();
  const brandId: number = workspaceBrandId || (brand ? brand[0].id : 0);
  const [createStory, setCreateStory] = useState(false);
  const [stories, setStories] = useState<Array<ISingleOption>>([]);

  const fetchEmbeds = () => {
    axiosInstant
      .get(getBrandEmbeds(brandId, 1000, 0))
      .then((response) => {
        const output = (response.data.rows || [])?.map((e: IEmbed) => {
          if (!e.id || !e.name) return null;
          return { id: e.id, name: e.name };
        });
        setStories(output.filter((e: ISingleOption) => !!e));
      })
      .catch((error) => {
        console.error(error.response);
      });
  };

  // refreshKey: stories are creatable from card menus while this stays
  // mounted (keepMounted popover) — the host bumps the key per open so the
  // list picks up stories created since the last open.
  useEffect(fetchEmbeds, [refreshKey]);

  return (
    <>
      <SingleFilter
        {...getFilterProps(stories, "embed", "Story")}
        updateSearch={onFilterSelect}
        onCreateNew={creatable ? () => setCreateStory(true) : undefined}
        icon={IconStory}
      />
      {createStory && (
        <CreateNewStory
          onClose={() => setCreateStory(false)}
          refetchEmbeds={fetchEmbeds}
        />
      )}
    </>
  );
};
